import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Store, Trophy, User } from 'lucide-react';
import { cn } from '@/lib/utils';

const NAV = [
  { path: '/salesman', label: 'Dashboard', icon: Home },
  { path: '/salesman/catalog', label: 'Katalog', icon: Store },
  { path: '/salesman/leaderboard', label: 'Leaderboard', icon: Trophy },
  { path: '/salesman/account', label: 'Akun', icon: User },
];

export default function BottomNav() {
  const location = useLocation();
  return (
    <nav data-testid="salesman-bottom-nav" className="fixed bottom-0 left-0 right-0 z-50 border-t bg-card shadow-[0_-4px_16px_rgba(15,23,42,0.06)]">
      <div className="mx-auto max-w-md grid grid-cols-4">
        {NAV.map((n) => {
          const active = location.pathname === n.path;
          const Icon = n.icon;
          return (
            <Link key={n.path} to={n.path} data-testid={`salesman-nav-${n.label.toLowerCase()}`} className={cn(
              'flex flex-col items-center justify-center py-2.5 gap-1 text-[11px] transition-colors',
              active ? 'text-primary' : 'text-muted-foreground'
            )}>
              <Icon className="h-5 w-5" />
              <span>{n.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
